import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import './ProfileSetupModal.css';

const ProfileSetupModal = ({ isOpen, user, onComplete, updateUserProfile }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = name.trim();
    
    if (!trimmedName) {
      setError('Please enter a name');
      return;
    }
    
    if (trimmedName.length < 1 || trimmedName.length > 120) {
      setError('Name must be between 1 and 120 characters');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Check if username already exists
      const { data: existingUser } = await supabase
        .from('users')
        .select('name')
        .eq('name', trimmedName)
        .single();

      if (existingUser) {
        setError('This name is already taken. Please choose another.');
        setLoading(false);
        return;
      }

      // Create or update user profile using AuthContext method
      if (updateUserProfile) {
        const result = await updateUserProfile({ name: trimmedName });
        if (!result.success) {
          throw new Error(result.error || 'Failed to update profile');
        }
      } else {
        // Fallback to direct Supabase call if updateUserProfile not available
        const { error: upsertError } = await supabase
          .from('users')
          .upsert({
            id: user.id,
            name: trimmedName,
            updated_at: new Date().toISOString()
          });

        if (upsertError) throw upsertError;
      }

      onComplete(trimmedName);
    } catch (error) {
      console.error('Error creating profile:', error);
      setError('Failed to create profile. Please try again.');
    }
    
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="profile-setup-overlay">
      <div className="profile-setup-modal">
        <div className="profile-setup-content">
          <h2>Welcome to Shameless!</h2>
          <p>To start commenting and participating in discussions, please choose a display name.</p>
          
          {error && (
            <div className="profile-setup-error">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="profile-setup-form">
            <div className="profile-input-group">
              <label htmlFor="name">Display Name</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your display name"
                required
                disabled={loading}
                maxLength={50}
              />
              <small>This is how other users will see you in comments and discussions.</small>
            </div>
            
            <button 
              type="submit" 
              className="profile-setup-btn"
              disabled={loading || !name.trim() || name.trim().length > 120}
            >
              {loading ? 'Creating Profile...' : 'Complete Setup'}
            </button>
          </form>
          
          <div className="profile-setup-footer">
            <p>You can change your display name later in your profile settings.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSetupModal;
